'use client'

import PropTypes from 'prop-types'
import MUITooltip from '@mui/material/Tooltip'
import MUIIconButton from '@mui/material/IconButton'

export const CustomDataFieldOverflowMenuItem = ({ icon, tooltip, onClick, sx, disabled }) => {
  const Component = icon

  return (
    <MUITooltip title={disabled ? null : tooltip} arrow placement="top">
      <MUIIconButton
        onClick={onClick}
        sx={{
          height: '36px',
          width: '36px',
          ':hover path': {
            stroke: disabled ? '#3D517B8F' : '#3D517B'
          },
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
          ...sx
        }}
      >
        <Component sx={{ width: '20px', height: '20px', color: '#3D517B8F' }} />
      </MUIIconButton>
    </MUITooltip>
  )
}

CustomDataFieldOverflowMenuItem.propTypes = {
  icon: PropTypes.any,
  tooltip: PropTypes.any,
  onClick: PropTypes.func,
  sx: PropTypes.object,
  disabled: PropTypes.bool
}
